import React from "react";

const ColorPickerClose = ({ removeBgColor, index, keyName }) => {
  return (
    <div
      className="position-absolute d-flex align-items-center justify-content-center rounded-circle"
      style={{
        top: "0px",
        right: "0px",
        cursor: "pointer",
        width: "18px",
        height: "18px",
        backgroundColor: "#dc3545",
      }}
      onClick={() =>
        keyName ? removeBgColor(keyName, index) : removeBgColor(index)
      }
    >
      <i
        className="bx bx-x"
        style={{
          fontSize: "14px",
          color: "#fff",
        }}
      />
    </div>
  );
};

export default ColorPickerClose;
